<template>
  <b-container fluid>
    <b-row>
      <b-col sm="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">Danh sách</h4>
          </template>
          <template v-slot:body>
            <div class="table-responsive">
              <b-table
                id="user-list-table"
                ref="userListTableRef"
                :items="userList"
                :fields="userFields"
                :striped="false"
                :outlined="true"
                :small="true"
                :hover="true"
                :busy.sync="isBusy"
                :current-page="currentPage"
                :per-page="localItemsPerPage"
                :primary-key="'id'"
                class="table-striped table-bordered mt-1"
                role="grid"
                aria-describedby="user-list-page-info"
              >
                <template v-slot:cell(status)="data">
                  <b-badge v-show="data.item.active === '1'" variant="primary">Hoạt động</b-badge>
                  <b-badge v-show="data.item.active === '0'" variant="danger">Khóa</b-badge>
                </template>
                <template v-slot:cell(username)="data">
                  <div class="flex align-items-center list-user-action">
                    <input type="hidden" v-model="data.item.toggle">
                    {{data.item.space}}
                    <i v-show="data.item.number_of_member > 0 && data.item && !data.item.toggle" @click="fetchMember(data.index)" class="las la-caret-square-right"/>
                    <i v-show="data.item.number_of_member > 0 && data.item && data.item.toggle" @click="recursiveCloseSquare(data.item.id, false)" class="las la-caret-square-down"/>
                    {{data.item.username}}
                  </div>
                </template>
                <template v-slot:cell(action)="data">
                  <div class="flex align-items-center list-user-action">
                    <router-link :to="{name:'user-manage.detail', params: {code: data.item.id}}">
                      <a
                        class="iq-bg-primary"
                        data-toggle="tooltip"
                        data-placement="top"
                        title
                        data-original-title="Xem chi tiết"
                      >
                      <i class="las la-list"></i>
                    </a>
                    </router-link>
                  </div>
                </template>
              </b-table>
<!--              <b-pagination-->
<!--                @change="pageChange"-->
<!--                v-model="currentPage"-->
<!--                :total-rows="totalRows"-->
<!--                :per-page="localItemsPerPage"-->
<!--                align="center"-->
<!--                size="md"-->
<!--                class="mt-3"-->
<!--              ></b-pagination>-->
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { findash } from '../../config/pluginInit'
import { skeletorData } from '@/utils'
import api from '../../store/api'

export default {
  name: 'UserList',
  async mounted () {
    findash.index()
    this.userList = await this.loadPage()
  },
  data () {
    return {
      currentPage: 1,
      totalRows: 100, // need to get this from server side
      perPage: 5, //
      localItemsPerPage: 0, // if you want use SSR
      isBusy: false,
      userFields: [
        {
          key: 'username',
          label: 'Tên tài khoản',
          thStyle: { width: '30%' }
        },
        {
          key: 'fullname',
          label: 'Họ tên'
        },
        {
          key: 'status',
          label: 'Trạng thái',
          class: 'text-center'
        },
        {
          key: 'last_login',
          label: 'Lần cuối đăng nhập',
          class: 'text-center'
        },
        {
          key: 'action',
          label: '',
          class: 'text-center'
        }
      ],
      userList: []
    }
  },
  computed: {
  },
  methods: {
    // loadPage (currentPage, perPage) {
    async loadPage () {
      this.isBusy = true

      let response = await api.sub_account.list()

      this.isBusy = false

      return skeletorData(response)
    }
    //
    // async fetchMember (index) {
    //   this.isBusy = true
    //   let promise = axios.get('https://mockupdata-73b6b-default-rtdb.asia-southeast1.firebasedatabase.app/mock2.json')
    //
    //   let response = await promise
    //
    //   let childMembers = skeletorData(response.data)
    //   //
    //   let that = this
    //   let currentIndex = index + 1 // after the current index
    //   let currentLevel = this.userList[index].level
    //
    //   skeletorDataParent(childMembers, this.userList[index].id, currentLevel)
    //
    //   _.each(childMembers, (e) => {
    //     // must use shadow copy splice if want to change data
    //     that.userList.splice(currentIndex, 0, e) // insert into array at position
    //     currentIndex++
    //   })
    //
    //   this.userList[index].toggle = true
    //
    //   this.isBusy = false
    // },
    // async recursiveCloseSquare (id, isChild) {
    //   let that = this
    //   let childrenClose = _.filter(this.userList, (e) => {
    //     return e.parentId === id
    //   })
    //   _.each(childrenClose, (e) => {
    //     that.recursiveCloseSquare(e.id, true)
    //   })
    //
    //   let index = _.findIndex(this.userList, (e) => e.id === id)
    //
    //   this.userList[index].toggle = false
    //
    //   // only use with shallow copy method like splice only
    //   if (isChild) { this.userList.splice(index, 1) }
    // }
    // async pageChange (page) {
    //   this.userList = await this.loadPage(page, this.perPage)
    // }
  }
}
</script>
